import { groupByMultiKey } from "../../Utils"

export const options = [
    { bookingTypeId: 1, bookingType: 'Confirm', id: 'C' },
    { bookingTypeId: 2, bookingType: 'Phone', id: 'P' },
    { bookingTypeId: 3, bookingType: 'Agent', id: 'AC' },
    { bookingTypeId: 4, bookingType: 'Branch', id: 'BC' },
    { bookingTypeId: 5, bookingType: 'Guest', id: 'G' },
]
export const optionsAutoCancel = [
    { autoCancelId: 1, autoCancel: 'Before Departure', },
    { autoCancelId: 2, autoCancel: 'After Booking', },
    { autoCancelId: 3, autoCancel: 'After Departure', },
]
export const optionsStatus = [
    { statusId: 1, status: 'Confirm', },
    { statusId: 2, status: 'Phone', },
]
export const optionsPayout = [
    { payoutId: 'C', payout: 'Commission', },
    { payoutId: 'N', payout: 'Netrate', },
]
export const optionsAgentType = [
    { agentTypeId: 1, agentType: 'Postpaid', },
    { agentTypeId: 2, agentType: 'Prepaid', },
]
export const genderOptions = [
    { value: 'MALE', label: 'M' },
    { value: 'FEMALE', label: 'F' },
];
export const focusElemnt = (elementID) => {
    elementID &&
        document.getElementById(elementID) &&
        document.getElementById(elementID).focus();
};
export const seatDataCombine = (value) => {
    if (value) {
        return `1~${value?.SeatLabel}~passenger-seat~${value?.gender?.[0]?.value || 'M'}~${value?.age || '25'}~${value?.baseFare || 0}~${value?.pickChrg || 0}~${value?.dropoffChrg || 0}`
    } else {
        return "1~~~M~0~0~0~0"
    }
}

export const instaBookingTableCol = [
    { headerName: 'Seat', field: 'SeatLabel', style: { width: '20px', textAlign: 'left' } },
    { headerName: 'Rates', field: 'baseFare', style: { width: '50px', textAlign: 'left' } },
    { headerName: 'Concession', field: 'concession', style: { width: '130px', textAlign: 'left' } },
    { headerName: 'Fare', field: 'fare', style: { width: '55px', textAlign: 'right' } },
    { headerName: 'Scan', field: 'scan', style: { width: '40px', textAlign: 'left' } },
]

export const couponList = [
    { id: 1, label: 'Open Ticket' },
    { id: 3, label: 'Prepaid Card' },
    { id: 2, label: 'Discount Coupon' },
]

export const paymentModeList = [
    { id: 1, label: 'Cash' },
]

export const instaBkgFare = [200, 300, 400, 500, 600, 700, 800, 900, 950, 1000, 1100, 1200]

export const redCouponList = [
    {
        header: 'Prepaid Card', list: [
            { coupon: 'PC636197929096', rupess: '28', name: 'Prepaid Card' },
            { coupon: 'PC636197929096', rupess: '28', name: 'Prepaid Card' },
        ]
    }
]


export const passDetailTableCol = [
    { headerName: 'Seat', field: 'SeatLabel', style: { textAlign: 'left' }, disabled: true, type: 'text' },
    { headerName: 'Gender', field: 'gender', style: { textAlign: 'left' }, disabled: false, type: 'number' },
    { headerName: 'Age', field: 'age', style: { textAlign: 'left' }, disabled: false, type: 'number' },
    { headerName: 'Rates', field: 'baseFare', style: { textAlign: 'left' }, disabled: false, type: 'number' },
    { headerName: 'Book Rate', field: 'bookRate', style: { textAlign: 'left' }, disabled: true, type: 'number' },
    { headerName: 'Scan', field: 'scan', style: { textAlign: 'left' }, disabled: true, type: 'number' },

]
export const generateTripSheetData = (reportData) => {
    // Extracting trip details
    const tripSheetList = [
        { name: "Trip Id", value: reportData[0]?.tripid || '' },
        { name: "Bus Number", value: reportData[0]?.BusNo || '' },
        { name: "User", value: reportData[0]?.BookedByUserName || '' },
        { name: "Branch", value: reportData[0]?.BranchName || '' },
        { name: "Driver Code", value: '' }, // No driver info in reportData
        { name: "Journey Date", value: reportData[0]?.JourneyDate || '' },
        { name: "Depart Time", value: reportData[0]?.DepartureTime || '' },
        { name: "Print Time", value: reportData[0]?.PrintTime || '' },
        { name: "Route", value: reportData[0]?.SubRouteNameShort || '' },
        { name: "Booked Bus Seats", value: reportData.length.toString() },
        { name: "Bus Booking Amt", value: `Rs. ${reportData.reduce((sum, item) => sum + item.TotalFare, 0).toFixed(2)}` },
        { name: "Luggage Total", value: 'Rs. 0.00' },
        { name: "Concession Total", value: `Rs. ${reportData.reduce((sum, item) => sum + item.ConcessionAmount, 0).toFixed(2)}` },
        { name: "Total Amount", value: `Rs. ${reportData.reduce((sum, item) => sum + item.NetFare, 0).toFixed(2)}` },
    ];

    // Define table columns
    const tableCol = [
        { headerName: "Seat No.", field: "seat", style: { textAlign: 'left' } },
        { headerName: "Primary Name", field: "CustomerName", style: { textAlign: 'left' } },
        { headerName: 'Total Fare', field: "fare", style: { textAlign: 'right' } }
    ];
    let groupData = groupByMultiKey(reportData, ['BranchName'])
    let newData = []
    Object.keys(groupData).forEach((key) => {
        const updateData = groupedDataTripSheet(groupData[key]);
        newData = [...newData, ...updateData]
    })
    return { tripSheetList, tableCol, cardData: newData };
};

const groupedDataTripSheet = (data) => {
    let subDataGroup = groupByMultiKey(data, ['PNRNo'])
    let newData = []
    Object.keys(subDataGroup).forEach((key) => {
        const updateData = groupTripSheetCard(subDataGroup[key]);
        newData = [...newData, ...updateData]
    })
    return [{ isHeader: true, ...newData[0], branchData: newData }]
}
const groupTripSheetCard = (data) => {
    let newData = []
    data.forEach((obj) => {
        let seatData = obj?.AllSeats?.split(',')
        let psgData = seatData.map((item, index) => ({
            ...obj,
            seat: item,
            fare: obj.SeatwiseFare?.split(',')?.[index] || 0

        }))
        newData.push({ ...obj, psgData: psgData })
    })
    return newData

}

export const runOptList = [
    { name: 'Daily', value: 1 },
    { name: 'Alternate', value: 2 },
    { name: 'Weekly', value: 3 },
]

export const weeklyList = [
    { id: 1, name: 'Mon', field: 'isMon' },
    { id: 2, name: 'Tue', field: 'isTue' },
    { id: 3, name: 'Wed', field: 'isWed' },
    { id: 4, name: 'Thur', field: 'isThur' },
    { id: 5, name: 'Fri', field: 'isFri' },
    { id: 6, name: 'Sat', field: 'isSat' },
    { id: 7, name: 'Sun', field: 'isSun' },
]


export const ValueTypeOpt = [
    { name: 'Amount', id: 0 },
    { name: 'Percentage', id: 1 },
]

export const autoIncreaseForAmtOpt = [
    { name: 'Auto Increase', id: 0 },
    { name: 'Auto Decrease', id: 1 },
    { name: 'Auto Fill', id: 2 },
]


export const autoIncreaseForPreOpt = [
    { name: 'Auto Increase', id: 0 },
    { name: 'Auto Decrease', id: 1 },
]

export const getObjectByBookingRightsID = (array, id) => array.find(item => item.BookingRightsID === id);

export const amPmTypeList = [
    { name: 'AM', id: 1 },
    { name: 'PM', id: 2 },
]
export const minList = Array.from({ length: 60 }, (_, i) => ({
    name: i.toString().padStart(2, '0'), // "00", "01", ..., "59"
    id: i
}));
export const hrList = Array.from({ length: 12 }, (_, i) => ({
    name: (i + 1).toString().padStart(2, '0'), // "01", "02", ..., "12"
    id: i + 1
}));
export function filterTrips(trips, fromCityId, toCityId) {
    return trips.filter(trip =>
        trip.FromCityID === fromCityId && trip.ToCityID === toCityId
    );
}
export function parseTime(timeStr) {
    // Split "06:57 AM" -> ["06:57", "AM"]
    const [time, period] = timeStr.split(" ");
    const [hrs, mins] = time.split(":");

    const hrsObj = { name: hrs, id: parseInt(hrs, 10) };
    const minsObj = { name: mins, id: parseInt(mins, 10) };

    const ampmObj = period === "AM"
        ? { name: "AM", id: 1 }
        : { name: "PM", id: 2 };

    return { hrsObj, minsObj, ampmObj };
}
export function formatTime(hoursArr, minutesArr, ampmArr) {
    // Extract the first element's name from each array
    const hours = hoursArr[0]?.name || "00";
    const minutes = minutesArr[0]?.name || "00";
    const ampm = ampmArr[0]?.name || "";

    // Return formatted time
    return `${hours}:${minutes} ${ampm}`.trim();
}

const BOOKING_TYPE_CODES = [
    "C", "P", "BC", "BP", "AC", "AP", "G", "Q",
    "AL", "ACO", "ACW", "API", "W"
];

const BOOKING_TYPE_LABELS = [
    "Confirm", "Phone", "Branch (C)", "Branch (P)",
    "Agent (C)", "Agent (P)", "Guest", "Quota",
    "Hold", "OffAgent(C)", "WalletCard(C)",
    "API Agent Confirm", "WaitList(W)"
];

const resolveBookingTypeCode = (bkgType = "") => {
  if (!bkgType.includes("-")) return bkgType;

  const [baseCode, ...rest] = bkgType.split("-");
  const sourceText = rest.join("-").toLowerCase();

  if (baseCode === "AC" && sourceText.includes("api")) {
    return "API";
  }

  if (baseCode === "AC") {
    return "AC";
  }

  return baseCode;
};
const getColorFromMaster = (code, bookingTypeMaster = []) => {
  const found = bookingTypeMaster.find(
    item => item.BookingTypeCode === code
  );

  return found?.ColorCode
    ? `rgb(${found.ColorCode})`
    : "rgb(200,200,200)"; // fallback
};
export const buildBookingSummary = (
  bookingTable = [],
  bookingTypeMaster = []
) => {
  // Step 1: base array from hardcoded constants
  const result = BOOKING_TYPE_CODES.map((code, index) => ({
    bookingTypeCode: code,
    bookingTypeLabel: BOOKING_TYPE_LABELS[index],
    totalSeatBooked: 0,
    fare: 0,
    colorCode: getColorFromMaster(code, bookingTypeMaster)
  }));

  // Step 2: aggregate booking data
  bookingTable.forEach(row => {
    const resolvedCode = resolveBookingTypeCode(row.BkgType);

    const target = result.find(
      item => item.bookingTypeCode === resolvedCode
    );

    if (target) {
      target.totalSeatBooked += Number(row.TotalSeatCount || 0);
      target.fare += Number(row.TotalFare || 0);
    }
  });

  return result;
};

